export default __webpack_public_path__ + "images/0x05e31a691405d06708a355c029599c12d5da8b28.png";